import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { ErrorBoundary } from '@sentry/react';
import { ButtonIcon, CardHeader, Typography } from '@statsbomb/kitbag-components';
import { ReactNode } from 'react';
import { GeneralErrorBoundaryFallback } from '../errorBoundary/ErrorBoundaryFallback';

/**
 * This component should be used to hold the controls which
 * appear in the top heading of our 50/50 layout.
 */
export const SectionControlsWrapper = ({
  heading,
  headerComponent,
  testId = 'child-components',
  children,
}: {
  heading: string;
  headerComponent?: ReactNode;
  testId?: string;
  children?: ReactNode;
}) => {
  const { t } = useTranslation('general');
  const { pathname, search } = useLocation();
  const isVideoPreview = pathname.includes('video/preview');
  const theme = useTheme();
  const isTouch = theme.mqMatch('md');

  return (
    <ErrorBoundary fallback={<GeneralErrorBoundaryFallback />}>
      <div className="bg-canvas-tertiary-main [&>header]:!pl-4">
        <CardHeader>
          <div className="flex items-center gap-2">
            {isVideoPreview && !isTouch && (
              <Link to={`.${search}`}>
                <ButtonIcon icon="DoubleChevronRight" size="small" displayText="right" variant="ghost">
                  {t('filters.other')}
                </ButtonIcon>
              </Link>
            )}
            <Typography variant="headingRegular" className="pr-2">
              {heading}
            </Typography>
          </div>
          {headerComponent}
          <div className="ml-auto flex items-center gap-2" data-testid={testId}>
            {children}
          </div>
        </CardHeader>
      </div>
    </ErrorBoundary>
  );
};
